export default __webpack_public_path__ + "static/placeholder3-7283390e9ddc3c4e74dd6ff0816a5322.jpg";